import React from 'react';

import MobileDataTableCard from '../../../../../DataTables/MobileDataTableCard';
import AdvancedDataTable from '../../../../../DataTables/AdvancedDataTable';

export default function QuarterbackCollegeAdvancedPassingStatsTable(props) {
	return (
		<div>
			<div className="text-xl py-2">
				<h4>{props.title}</h4>
			</div>
			<div className="contents lg:hidden">
				<MobileDataTableCard
					data={props.data}
					style="text-gray-800 dark:text-dark-text border-b border-gray-300 dark:border-dark-border font-semibold"
					rowRenderer={(row) => {
						const labels = [
							{
								displayName: 'Category',
								apiName: 'category',
								alignment: 'left'
							},
							{
								displayName: 'Completions Per Game',
								apiName: 'college_pass_completions_per_game',
								alignment: 'left'
							},
							{
								displayName: 'Attempts Per Game',
								apiName: 'college_pass_attempts_per_game',
								alignment: 'left'
							},
							{
								displayName: 'Yards Per Game',
								apiName: 'college_passing_yards_per_game',
								alignment: 'left'
							},
							{
								displayName: 'TDs  Per Game',
								apiName: 'college_passing_touchdowns_per_game',
								alignment: 'left'
							},
							{
								displayName: 'Interceptions Per Game',
								apiName: 'college_interceptions_per_game',
								alignment: 'left'
							},
							{
								displayName: 'Yards Per Completion',
								apiName: 'college_passing_yards_per_completion',
								alignment: 'left'
							},
							{
								displayName: 'Yards Per Attempt',
								apiName: 'college_passing_yards_per_attempt',
								alignment: 'left'
							},
							{
								displayName: 'Completions Per TD',
								apiName: 'college_pass_completions_per_touchdown',
								alignment: 'left'
							},
							{
								displayName: 'Attempts Per TD',
								apiName: 'college_pass_attempts_per_touchdown',
								alignment: 'left'
							},
							{
								displayName: 'Yards Per TD',
								apiName: 'college_passing_yards_per_touchdown',
								alignment: 'left'
							},
							{
								displayName: 'Completions Per INT',
								apiName: 'college_pass_completions_per_interception',
								alignment: 'left'
							},
							{
								displayName: 'Attempts Per INT',
								apiName: 'college_pass_attempts_per_interception',
								alignment: 'left'
							},
							{
								displayName: 'Yards Per INT',
								apiName: 'college_passing_yards_per_interception',
								alignment: 'left'
							},
							{
								displayName: 'TDs Per INT',
								apiName: 'college_passing_touchdowns_per_interception',
								alignment: 'left'
							}
						];
						return (
							<div
								key={`${row.first_name} ${row.last_name} - PlayersProfileStatsTable - MobileDataTableCard`}
								className="p-5 bg-white dark:bg-dark-card border-t border-gray-200 dark:border-dark-border text-gray-800 dark:text-dark-text"
							>
								<div className="flex flex-wrap">
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[1].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_pass_completions_per_game}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[2].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_pass_attempts_per_game}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[3].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_passing_yards_per_game}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[4].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_passing_touchdowns_per_game}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[5].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_interceptions_per_game}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[6].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_passing_yards_per_completion}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[7].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_passing_yards_per_attempt}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[8].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_pass_completions_per_touchdown}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[9].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_pass_attempts_per_touchdown}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[10].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_passing_yards_per_touchdown}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[11].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_pass_completions_per_interception}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[12].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_pass_attempts_per_interception}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[13].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_passing_yards_per_interception}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[14].displayName}
									</div>
									<div className="w-1/2">
										{row.college_passing_touchdowns_per_interception}
									</div>
								</div>
							</div>
						);
					}}
				/>
			</div>
			<div className="hidden lg:contents">
				<AdvancedDataTable
					data={props.data}
					style="text-gray-800 dark:text-dark-text border-b border-gray-300 dark:border-dark-border font-semibold"
					columns={[
						{
							displayName: 'Category',
							apiName: 'category',
							alignment: 'left'
						},
						{
							displayName: 'Completions Per Game',
							apiName: 'college_pass_completions_per_game',
							alignment: 'left'
						},
						{
							displayName: 'Attempts Per Game',
							apiName: 'college_pass_attempts_per_game',
							alignment: 'left'
						},
						{
							displayName: 'Yards Per Game',
							apiName: 'college_passing_yards_per_game',
							alignment: 'left'
						},
						{
							displayName: 'TDs  Per Game',
							apiName: 'college_passing_touchdowns_per_game',
							alignment: 'left'
						},
						{
							displayName: 'Interceptions Per Game',
							apiName: 'college_interceptions_per_game',
							alignment: 'left'
						},
						{
							displayName: 'Yards Per Completion',
							apiName: 'college_passing_yards_per_completion',
							alignment: 'left'
						},
						{
							displayName: 'Yards Per Attempt',
							apiName: 'college_passing_yards_per_attempt',
							alignment: 'left'
						},
						{
							displayName: 'Completions Per TD',
							apiName: 'college_pass_completions_per_touchdown',
							alignment: 'left'
						},
						{
							displayName: 'Attempts Per TD',
							apiName: 'college_pass_attempts_per_touchdown',
							alignment: 'left'
						},
						{
							displayName: 'Yards Per TD',
							apiName: 'college_passing_yards_per_touchdown',
							alignment: 'left'
						},
						{
							displayName: 'Completions Per INT',
							apiName: 'college_pass_completions_per_interception',
							alignment: 'left'
						},
						{
							displayName: 'Attempts Per INT',
							apiName: 'college_pass_attempts_per_interception',
							alignment: 'left'
						},
						{
							displayName: 'Yards Per INT',
							apiName: 'college_passing_yards_per_interception',
							alignment: 'left'
						},
						{
							displayName: 'TDs Per INT',
							apiName: 'college_passing_touchdowns_per_interception',
							alignment: 'left'
						}
					]}
					rowRenderer={(row) => {
						return (
							<tr key={row.id} className="bg-white dark:bg-dark-card border-t border-gray-200 dark:border-dark-border text-gray-800 dark:text-dark-text">
								<td className="pl-8 py-3 text-left sticky left-0 bg-white dark:bg-dark-card z-10 text-gray-800 dark:text-dark-text">
									Career
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_pass_completions_per_game}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_pass_attempts_per_game}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_passing_yards_per_game}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_passing_touchdowns_per_game}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_interceptions_per_game}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_passing_yards_per_completion}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_passing_yards_per_attempt}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_pass_completions_per_touchdown}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_pass_attempts_per_touchdown}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_passing_yards_per_touchdown}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_pass_completions_per_interception}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_pass_attempts_per_interception}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_passing_yards_per_interception}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_passing_touchdowns_per_interception}
								</td>
							</tr>
						);
					}}
				/>
			</div>
		</div>
	);
}
